module.exports = "/assets/data/aeabb0ce4abac24bf812f4678e2150a8-CF37.data.json";